var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Settings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.681,
    height: 146.682,
    viewBox: "0 0 146.681 146.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2aa8e0",
    d: "M1321.244 322.877l8.665-9.378a4.4 4.4 0 0 0 .367-5.944l-8.085-9.346a58.056 58.056 0 0 0 7.2-19.544l12.222-1.863a4.4 4.4 0 0 0 3.58-4.759l-.5-12.758a4.4 4.4 0 0 0-3.943-4.462l-12.332-.892a58.053 58.053 0 0 0-8.719-18.915l7.322-9.955a4.4 4.4 0 0 0-.834-5.9l-9.387-8.661a4.4 4.4 0 0 0-5.944-.367l-9.347 8.085a58.058 58.058 0 0 0-19.544-7.2l-1.862-12.223a4.4 4.4 0 0 0-4.76-3.58l-12.757.5a4.4 4.4 0 0 0-4.463 3.944l-.892 12.331a58.08 58.08 0 0 0-18.916 8.719l-9.955-7.322a4.4 4.4 0 0 0-5.9.835l-8.66 9.378a4.4 4.4 0 0 0-.366 5.945l8.084 9.346a58.066 58.066 0 0 0-7.2 19.544L1202.1 260.3a4.4 4.4 0 0 0-3.579 4.759l.5 12.758a4.4 4.4 0 0 0 3.943 4.462l12.331.893a58.069 58.069 0 0 0 8.72 18.915l-7.322 9.955a4.4 4.4 0 0 0 .834 5.9l9.378 8.665a4.4 4.4 0 0 0 5.944.367l9.346-8.085a58.09 58.09 0 0 0 19.544 7.2l1.863 12.222a4.4 4.4 0 0 0 4.76 3.58l12.757-.5a4.4 4.4 0 0 0 4.463-3.944l.892-12.331a58.077 58.077 0 0 0 18.915-8.719l9.955 7.322a4.4 4.4 0 0 0 5.9-.842zm-63.144-39.439a20.268 20.268 0 1 1 28.641-1.131 20.269 20.269 0 0 1-28.641 1.131z",
    opacity: 0.2,
    transform: "translate(-1198.516 -195.211)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Settings);
export default __webpack_public_path__ + "static/media/404-settings.ca08dd96.svg";
export { ForwardRef as ReactComponent };